// extracted by mini-css-extract-plugin
export default {"tab":"Tab--tab--oamEu","selected":"Tab--selected--Bb4GU"};